/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Edited.
*/

import React, { useRef, useMemo, useEffect, useState, useContext } from "react";
import {
  useGLTF,
  MeshReflectorMaterial,
  MapControls,
  Edges,
  Html,
  //OrbitControls,
  Merged,
  Instances,
  Instance,
} from "@react-three/drei";
import { TextureLoader } from "three/src/loaders/TextureLoader";
import { useFrame, useLoader, useThree } from "@react-three/fiber";
import {
  Quaternion,
  Vector3,
  Euler,
  PlaneBufferGeometry,
  BoxBufferGeometry,
  Vector2,
  RepeatWrapping,
  VideoTexture,
  sRGBEncoding,
  AudioListener,
  AudioLoader,
  MeshBasicMaterial,
  MathUtils,
  DoubleSide,
  MeshStandardMaterial,
  //MeshStandardMaterial,

  //HalfFloatType,
  //NearestFilter,
  //MeshStandardMaterial,
  //Object3D,
  //InstancedBufferGeometry,
  //SphereBufferGeometry,
} from "three";

import { EXRLoader } from "three-stdlib";

import { easings, SpringValue } from "react-spring";

import {
  useSpring as useSpringThree,
  animated as animatedThree,
} from "@react-spring/three";

import PointIcon from "../components/PointIcon";

let isPreStart = false;
let isStart = false;
let isLock = false;

let _delta = 0;
let _delta2 = 0;

const startP = new Vector3();
const startQ = new Quaternion();

import { UIContext } from "../pages/index";
import { saveAs } from "file-saver";

export default function Model({ ...props }) {
  const springValue = useMemo(() => {
    return new SpringValue();
  }, []);

  const mapRef = useRef(null);
  const group = useRef();

  const posA = useMemo(
    () =>
      new Vector3(24.682166724477618, 151.08654013835573, 159.87200417587854),
    []
  );

  // camera positions
  const cam_pos1 = useMemo(() => new Vector3(26.02, 151.16, 209.35), []);
  const cam_pos2 = useMemo(() => new Vector3(12.23, 21.71, 100.37), []);
  const cam_pos3 = useMemo(() => new Vector3(14.19, 19.8, 42.97), []);
  const cam_pos4 = useMemo(() => new Vector3(14.3, 19.75, 61.15), []);
  const cam_pos5 = useMemo(() => new Vector3(-66.89, 127.05, 83.93), []);
  const cam_pos6 = useMemo(() => new Vector3(47.9, 71.34, 112.43), []);

  const cam_rot1 = useMemo(() => new Euler(-0.46, 0.14, 0.07), []);
  const cam_rot2 = useMemo(() => new Euler(0.26, 0.09, -0.03), []);
  const cam_rot3 = useMemo(() => new Euler(0.28, 0.55, -0.15), []);
  const cam_rot4 = useMemo(() => new Euler(0.25, -0.76, 0.18), []);
  const cam_rot5 = useMemo(() => new Euler(-0.81, -0.44, -0.42), []);
  const cam_rot6 = useMemo(() => new Euler(-0.25, 0.41, 0.1), []);

  const cam_q1 = useMemo(() => new Quaternion().setFromEuler(cam_rot1), []);
  const cam_q2 = useMemo(() => new Quaternion().setFromEuler(cam_rot2), []);
  const cam_q3 = useMemo(() => new Quaternion().setFromEuler(cam_rot3), []);
  const cam_q4 = useMemo(() => new Quaternion().setFromEuler(cam_rot4), []);
  const cam_q5 = useMemo(() => new Quaternion().setFromEuler(cam_rot5), []);
  const cam_q6 = useMemo(() => new Quaternion().setFromEuler(cam_rot6), []);

  ////////////////////////////////////////////////////////////

  const { nodes, materials } = useGLTF("/models.glb");
  const normAsphalt = useLoader(TextureLoader, "/norm_asphalt.webp");

  normAsphalt.wrapS = RepeatWrapping;
  normAsphalt.wrapT = RepeatWrapping;

  const [isZoom, setZoom] = useState(false);

  const [res, SetRes] = useState({ x: 1, y: 1 });

  const [pos, SetPos] = useState(posA);
  const [q, SetQ] = useState(qAMap);
  const [bias, SetBias] = useState(1);

  const qAMap = useMemo(
    () =>
      new Quaternion(
        -0.3052573070623509,
        0.05882724215032874,
        0.018897337906766037,
        0.9502632386271005
      ),
    []
  );

  ////////////////////////////////////////////////////////////

  // center
  const c2 = useMemo(
    () => new Vector3(cam_pos2.x - 20, cam_pos2.y + 50, cam_pos2.z - 90),
    []
  );
  // left
  const c3 = useMemo(
    () => new Vector3(cam_pos3.x - 30, cam_pos3.y + 35, cam_pos3.z - 10),
    []
  );
  // right
  const c4 = useMemo(
    () => new Vector3(cam_pos4.x + 10, cam_pos4.y + 25, cam_pos4.z - 40),
    []
  );

  // left top
  const c5 = useMemo(
    () => new Vector3(cam_pos5.x, cam_pos5.y - 50, cam_pos5.z - 30),
    []
  );
  const c6 = useMemo(
    () => new Vector3(cam_pos6.x - 10, cam_pos6.y, cam_pos6.z - 30),
    []
  );

  ////////////////////////////////////////////////////////////

  function toggleVideo() {
    if (!ctx.transition.isVideoLoaded) {

      //const video = document.getElementById("video");
      console.log(video);
      //video.src = "/video.mp4"
      video.setAttribute("src", "/video.mp4");
      video.play();
      /*
      setVideo(() =>
        Object.assign(document.createElement("video"), {
          src: "/video.mp4",
          crossOrigin: "anonymous",
          display: "none",
          playsInline: true,
          loop: true,
        })
      );
      */
      ctx.transition.isVideoLoaded = true;
      
    }
  }

  

  const [video, setVideo] = useState(() =>
    Object.assign(document.createElement("video"), {
      id: "video",
      //src: "/video.mp4",
      crossOrigin: "anonymous",
      display: "none",
      playsInline: true,
      loop: true,
    })
  );

  /*
  const [video, setVideo] = useState(() =>
    Object.assign(document.createElement("video"), {
      src: "/video.mp4",
      crossOrigin: "anonymous",
      display: "none",
      playsInline: true,
      loop: true,
    })
  );
  */

  ////////////////////////////////////////////////////////////

  const texVideo = useMemo(() => new VideoTexture(video), [video]);

  texVideo.wrapS = RepeatWrapping;
  texVideo.wrapT = RepeatWrapping;
  texVideo.encoding = sRGBEncoding;

  const [patternIdx, setPatternIdx] = useState(0);

  const moveDuration = 1200;
  const moveEase = easings.easeOutQuint;

  function camMoveStart() {
    startP.set(camera.position.x, camera.position.y, camera.position.z);
    startQ.set(
      camera.quaternion.x,
      camera.quaternion.y,
      camera.quaternion.z,
      camera.quaternion.w
    );
  }

  function camMove(idx) {
    if (idx == 0) {
      if (isStart) {
        if (!isLock) {
          isLock = true;

          if (springValue.isAnimating) {
            springValue.stop();
          }

          if (isZoom) {
            setZoom(false);
            ctx.transition.isZoom = false;
          } else {
            setZoom(true);
            ctx.transition.isZoom = true;
          }
          springValue.start({
            from: 0,
            to: 1,
            config: { duration: moveDuration, easing: moveEase },
            onStart: () => {
              camMoveStart();
            },
            onChange: (e) => {
              camMoveChange(0, e);
            },
            onRest: () => {
              if (!isZoom) {
                setZoom(false);
                ctx.transition.isZoom = false;
              } else {
              }

              isLock = false;
            },
          });
        }
      }
    } else {
      if (springValue.isAnimating) {
        springValue.stop();
      }

      if (isStart && !springValue.isAnimating) {
        setZoom(true);
        camSet(idx);

        ctx.transition.isZoom = true;
        springValue.start({
          from: 0,
          to: 1,
          config: { duration: moveDuration, easing: moveEase },

          onStart: () => {
            camMoveStart();
          },
          onChange: (e) => {
            camMoveChange(idx, e);
          },
          onRest: () => {
            if (ctx.transition.isZoom) {
              ctx.transition.isZoomEnd = true;
            }
          },
        });
      }
    }
  }

  function camSet(idx) {
    if (idx == 0) {
      SetPos(posA);
      SetQ(qAMap);
    } else if (idx == 1) {
      SetPos(cam_pos2);
      SetQ(cam_q2);
    } else if (idx == 2) {
      SetPos(cam_pos3);
      SetQ(cam_q3);
    } else if (idx == 3) {
      SetPos(cam_pos4);
      SetQ(cam_q4);
    } else if (idx == 4) {
      SetPos(cam_pos5);
      SetQ(cam_q5);
    } else if (idx == 5) {
      SetPos(cam_pos6);
      SetQ(cam_q6);
    } else {
    }
  }

  function camMoveChange(idx, e) {
    if (idx == 0) {
      camera.position.lerpVectors(startP, posA, e);
      camera.quaternion.slerpQuaternions(startQ, qAMap, e);
    } else if (idx == 1) {
      camera.position.lerpVectors(startP, cam_pos2, e);
      camera.quaternion.slerpQuaternions(startQ, cam_q2, e);
      SetBias(4);
    } else if (idx == 2) {
      camera.position.lerpVectors(startP, cam_pos3, e);
      camera.quaternion.slerpQuaternions(startQ, cam_q3, e);
      SetBias(0.5);
    } else if (idx == 3) {
      camera.position.lerpVectors(startP, cam_pos4, e);
      camera.quaternion.slerpQuaternions(startQ, cam_q4, e);
      SetBias(0.5);
    } else if (idx == 4) {
      camera.position.lerpVectors(startP, cam_pos5, e);
      camera.quaternion.slerpQuaternions(startQ, cam_q5, e);
      SetBias(15);
    } else if (idx == 5) {
      camera.position.lerpVectors(startP, cam_pos6, e);
      camera.quaternion.slerpQuaternions(startQ, cam_q6, e);
      SetBias(6);
    } else {
    }
  }

  function changePattern(idx) {
    if (idx == 0 || idx == 1) {
      setPatternIdx(idx);
    } else if (idx == 2) {
      setPatternIdx(idx);
      if(ctx.transition.isVideoLoaded){
        video.play();
      }
    }
  }

  function cameraStart() {
    if (!isPreStart) {
      isPreStart = true;

      springValue.start({
        from: 80,
        to: 43.78,
        config: { duration: 800, easing: easings.easeInOutQuart },
        onChange: (e) => {
          camera.fov = e;
          camera.updateProjectionMatrix();
        },
        onRest: () => {
          isStart = true;
          setMapEnable(true);
        },
      });
    }
  }

  function cameraDefaultAngle() {
    if (isStart) {
      if (!isLock) {
        isLock = true;

        if (springValue.isAnimating) {
          springValue.stop();
        }
        ctx.transition.isZoomEnd = false;

        if (isZoom) {
          setZoom(false);
          ctx.transition.isZoom = false;
        } else {
          setZoom(true);
          ctx.transition.isZoom = true;
        }
        springValue.start({
          from: 0,
          to: 1,
          config: { duration: moveDuration, easing: moveEase },
          onStart: () => {
            camMoveStart();
          },
          onChange: (e) => {
            camMoveChange(0, e);
          },
          onRest: () => {
            if (!isZoom) {
              setZoom(false);
              ctx.transition.isZoom = false;
            }

            isLock = false;
          },
        });

        if (!ctx.pointIcon.display) {
          ctx.pointIcon.display = true;
        }
      }
    }
  }

  function toggleAudio() {
    if (!sound.current.isPlaying) {
      sound.current.play();
    } else {
      sound.current.stop();
    }
  }

  ////////////////////////////////////////////////////////////

  /*
  const crowdTex = useMemo(() => {
    const tex = new EXRLoader()
      .setDataType(HalfFloatType)
      .load("crowd.exr", (texture, textureData) => {
        tex.magFilter = NearestFilter;
        tex.minFilter = NearestFilter;
        //tex.flipY = true;
        console.log(textureData.header);
      });
    return tex;
  }, []);

  const matCrowd = useMemo(() => {
    const material = new MeshStandardMaterial({
      color: "#fff",
      depthWrite: true,
      depthTest: true,
    });

    console.log(crowdTex);
    material.userData.crowdTex = { value: crowdTex };

    material.onBeforeCompile = function (shader) {
      shader.uniforms.crowdTex = { value: crowdTex };

      shader.vertexShader =
        [
          `
          
        #define USE_UV;
        //#define USE_INSTANCING;

        attribute vec2 reference;
        uniform sampler2D crowdTex;
      `,
        ].join("\n") + shader.vertexShader;

      shader.vertexShader = shader.vertexShader.replace(
        "#include <project_vertex>",
        [
          `
          vec4 pos = texture2D(crowdTex, vUv);
          //vec4 mvPosition = vec4( transformed, 1.0 ) ;
          vec4 mvPosition = vec4( transformed, 1.0 );
          //#ifdef USE_INSTANCING
            //mvPosition = instanceMatrix * mvPosition;
          //#endif
          mvPosition = modelViewMatrix * mvPosition;
          gl_Position = projectionMatrix * mvPosition;
        `,
        ].join("\n")
      );

      shader.fragmentShader = shader.fragmentShader;
      material.userData.shader = shader;
    };

    return material;
  }, []);

  useFrame(() => {
    const shader = matCrowd.userData.shader;

    if (shader) {
      shader.uniforms.crowdTex.value = crowdTex;
    }
  });
  */
  /*
  const references = useMemo(() => {
    const size = 32;

    const length = size;
    const references = new Float32Array(32 * 2);

    for (let i = 0; i < 32; i++) {
      references[i * 2] = i / 32;
      references[i * 2 + 1] = 0;
      //references[i * 2 + 1] = ~~(i / size) / size;
    }

    return references;
  }, []);

  const geo = useMemo(() => {
    const geo = new BoxBufferGeometry(10, 100, 10, 3, 3, 3);
    return geo;
  }, []);
*/
  const instances = useMemo(
    () => ({
      Crowd1: nodes.crowd1,
      Crowd2: nodes.crowd2,
      Crowd3: nodes.crowd3,
      Crowd4: nodes.crowd4,
      Crowd5: nodes.crowd5,
    }),
    [nodes]
  );

  function Crowd() {
    return <Merged meshes={instances}>{() => {}}</Merged>;
  }

  function InstanceModel({ instances }) {
    const group = useRef();

    return (
      <>
        <instances.Crowd1
          position={[38.9953, 19.0, 47.146]}
          quaternion={[0.0, 0.944823, 0.0, -0.327581]}
        />
        <instances.Crowd1
          position={[5.12365, 19.0, 56.0789]}
          quaternion={[0.0, 0.433741, 0.0, -0.901038]}
        />
        <instances.Crowd1
          position={[5.32498, 19.0, 76.8296]}
          quaternion={[0.0, 0.999878, 0.0, 0.0156144]}
        />
        <instances.Crowd1
          position={[16.5214, 19.0, 69.9321]}
          quaternion={[-0.0, -0.615293, -0.0, 0.788298]}
        />
        <instances.Crowd1
          position={[35.5828, 19.0, 58.2693]}
          quaternion={[-0.0, -0.49702, -0.0, 0.867739]}
        />
        <instances.Crowd1
          position={[-0.340277, 19.0, 79.9204]}
          quaternion={[0.0, 0.459826, 0.0, -0.888009]}
        />
        <instances.Crowd1
          position={[23.7429, 19.0, 76.1625]}
          quaternion={[0.0, 0.942894, 0.0, 0.333093]}
        />
        <instances.Crowd1
          position={[20.159, 19.0, 63.9515]}
          quaternion={[0.0, 0.982756, 0.0, 0.184907]}
        />
        <instances.Crowd1
          position={[32.885, 19.0, 58.5378]}
          quaternion={[-0.0, -0.0738201, -0.0, -0.997272]}
        />
        <instances.Crowd1
          position={[12.8487, 19.0, 82.6045]}
          quaternion={[-0.0, -0.961127, -0.0, -0.276107]}
        />
        <instances.Crowd1
          position={[32.0263, 19.0, 64.6014]}
          quaternion={[-0.0, -0.957517, -0.0, 0.288376]}
        />
        <instances.Crowd1
          position={[-0.659469, 19.0, 76.3745]}
          quaternion={[0.0, 0.946442, 0.0, -0.322873]}
        />
        <instances.Crowd1
          position={[11.4914, 19.0, 55.6373]}
          quaternion={[0.0, 0.939912, 0.0, -0.341417]}
        />
        <instances.Crowd1
          position={[14.1457, 19.0, 71.8675]}
          quaternion={[-0.0, -0.933277, -0.0, 0.359156]}
        />
        <instances.Crowd1
          position={[16.8198, 19.0, 46.1279]}
          quaternion={[0.0, 0.139971, 0.0, -0.990156]}
        />
        <instances.Crowd1
          position={[21.5468, 19.0, 38.6364]}
          quaternion={[0.0, 0.403952, 0.0, 0.91478]}
        />
        <instances.Crowd1
          position={[2.42836, 19.0, 73.1626]}
          quaternion={[-0.0, -0.915933, -0.0, -0.401332]}
        />
        <instances.Crowd1
          position={[9.23738, 19.0, 61.2726]}
          quaternion={[0.0, 0.918001, 0.0, 0.396578]}
        />
      </>
    );
  }

  ////////////////////////////////////////////////////////////

  const material = useMemo(() => {
    return new MeshBasicMaterial();
  }, []);

  const matScreen = useMemo(() => {
    material.userData.uTime = { value: 0 };
    material.userData.uTime2 = { value: 0 };
    material.userData.patternIdx = { value: patternIdx };

    material.userData.pattern1hue = { value: 1 };
    material.userData.pattern1speed = { value: 1 };
    material.userData.pattern1brightness = {
      value: 1,
    };

    material.userData.pattern2length = {
      value: 0,
    };
    material.userData.pattern2brightness = {
      value: 1,
    };

    material.userData.pattern3hue = { value: 0 };
    material.userData.pattern3brightness = { value: 2.2 };
    material.userData.pattern3gamma = { value: 1 };

    material.onBeforeCompile = function (shader) {
      shader.uniforms.uTime = material.userData.uTime;
      shader.uniforms.uTime2 = material.userData.uTime2;
      shader.uniforms.patternIdx = material.userData.patternIdx;

      shader.uniforms.resX = { value: res.x };
      shader.uniforms.resY = { value: res.y };

      shader.uniforms.texVideo = { value: texVideo };

      shader.uniforms.pattern1hue = material.userData.pattern1hue;
      shader.uniforms.pattern1speed = material.userData.pattern1speed;
      shader.uniforms.pattern1brightness = material.userData.pattern1brightness;

      shader.uniforms.pattern2length = material.userData.pattern2length;
      shader.uniforms.pattern2brightness = material.userData.pattern2brightness;

      shader.uniforms.pattern3hue = material.userData.pattern3hue;
      shader.uniforms.pattern3gamma = material.userData.pattern3gamma;
      shader.uniforms.pattern3brightness = material.userData.pattern3brightness;

      shader.vertexShader =
        [
          `
          #define USE_UV;
        `,
        ].join("\n") + shader.vertexShader;

      shader.fragmentShader =
        [
          `
              varying vec2 vUv;
              uniform float uTime;
              uniform float uTime2;

              uniform float resX;
              uniform float resY;
            
              uniform sampler2D texVideo;
              uniform float patternIdx;

              uniform float pattern1hue;
              uniform float pattern1speed;
              uniform float pattern1brightness;

              uniform float pattern2length;
              uniform float pattern2brightness;

              uniform float pattern3hue;
              uniform float pattern3gamma;
              uniform float pattern3brightness;

              //////////////////////////////////////////////////////////////

              // https://www.shadertoy.com/view/ll2GD3
              // The MIT License
              // https://www.youtube.com/c/InigoQuilez
              // https://iquilezles.org/
              // Copyright © 2015 Inigo Quilez
              // Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions: The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

              vec3 pal( in float t, in vec3 a, in vec3 b, in vec3 c, in vec3 d )
              {
                  return a + b*cos( 6.28318*(c*t+d) );
              }

              //////////////////////////////////////////////////////////////
              // https://gist.github.com/mairod/a75e7b44f68110e1576d77419d608786?permalink_comment_id=3180018#gistcomment-3180018
              // viruseg

              vec3 Hue(vec3 color, float hue) {
                const vec3 k = vec3(0.57735, 0.57735, 0.57735);
                float cosAngle = cos(hue);
                return vec3(color * cosAngle + cross(k, color) * sin(hue) + k * dot(k, color) * (1.0 - cosAngle));
              }

              //////////////////////////////////////////////////////////////
                            
              vec3 brightnessContrast(vec3 value, float brightness, float contrast)
              {
                  return (value - 0.5) * contrast + 0.5 + brightness;
              }

              vec3 Gamma(vec3 value, float param)
              {
                  return vec3(pow(abs(value.r), param),pow(abs(value.g), param),pow(abs(value.b), param));
              }
            
              float random (in float x) {
                return fract(sin(x)*1e4);
              }
            
              float random (in vec2 st) {
                  return fract(sin(dot(st.xy, vec2(12.9898,78.233)))* 43758.5453123);
              }
            
              float pattern(vec2 st, vec2 v, float t) {
                  vec2 p = floor(st+v);
                  return step(t, random(100.+p*.000001));

              }

              mat2 rotate2d(float _angle){
                return mat2(cos(_angle),-sin(_angle),
                            sin(_angle),cos(_angle));
              }

              mat2 rotate(vec2 p, float theta){
                return mat2(cos(theta), -sin(theta), sin(theta), cos(theta));
              }

            `,
        ].join("\n") + shader.fragmentShader;

      shader.fragmentShader = shader.fragmentShader.replace(
        "#include <output_fragment>",
        [
          `                
          //////////////////////////////////////////////////////////////
          // https://github.com/redshift3d/RedshiftOSLShaders/blob/main/NoiseColor.osl
          // RedshiftOSLShaders/NoiseColor.osl
          // OSL Shader by Tomás Atria based on http://glslsandbox.com/ examples
          // Modified by Saul Espinosa 7/15/2021 for Redshift 3d
          //
          // Modified from OSL to GLSL

          vec2 st = vec2(vUv.x*resX * 0.4, vUv.y*resY*0.4);

          float Pi=10.;
          int complexity=30;
          float fluid_speed=600.;
          float color_intensity = 0.5;
          vec3 p=vec3(st.x,st.y,0.);
          p*=2.;
          
          for(int i=1;i<13;i++){
              vec3 newp=p+uTime* pattern1speed * .02;
              
              newp.x+=.6/float(i)*sin(float(i)*p.y+uTime/fluid_speed+20.3*float(i))+.5;
              newp.y+=.6/float(i)*sin(float(i)*p.x+uTime/fluid_speed+.3*float(i+10))-.5;

              p=newp;
          }
          vec3 noiseColor = vec3(color_intensity*sin(5.*p.x)+color_intensity,color_intensity*sin(3.*p.y)+color_intensity,color_intensity*sin(p.x+p.y)+color_intensity);
          
          noiseColor = Hue(noiseColor, pattern1hue);

          noiseColor = brightnessContrast(noiseColor, 0.1,.3);
          noiseColor= Gamma(noiseColor, 4.);
          noiseColor *= pattern1brightness;

          ////////////////////////////////////////////////////////////////////////

          vec2 _st = vUv;   
          _st -= vec2(0.5);
          _st = rotate2d(-0.5) * _st;
          _st += vec2(0.5);
          float nums = 56.0;
          vec2 grid = vec2(100.0, nums);
          _st *= grid;
      
          vec2 ipos = floor(_st);  // integer
          vec2 fpos = fract(_st);  // fraction
          float speed = 1.0;
          vec2 vel = vec2((uTime2 + 100.)  * speed * max(grid.x,grid.y)); // time
          float dir = -1.;          
          float a = random(1.0+ipos.y);
          vel *= vec2(dir, 0.) * random(1.0+ipos.y); // direction        
          vec3 col = vec3(0.);
          float line_length = 1.0-0.6;
          vec2 _p = floor(_st+vel);
          float lines = step(line_length, random(100.+_p.x*.000001));
          float width_threshold = 0.9;
          float width = 0.05 + random(ipos.y) * width_threshold;
          lines *= step(width, fpos.y);
          
          vec3 l = vec3(lines) * pal(_st.y*0.3 + uTime2 * 0.05, vec3(0.5, 0.5, 0.5), vec3(0.5, 0.5, 0.5), vec3(1.0, 1.0,	1.0), vec3(	0.00, 0.10, 0.20));

          l = Hue(l, pattern2length);
          vec3 final = l * pattern2brightness; 

          ////////////////////////////////////////////////////////////////////////

          vec3 vid = texture2D(texVideo,vec2(vUv.x, 1.-vUv.y)).rgb;
          vid = Gamma(vid, pattern3gamma);
          vid = Hue(vid, pattern3hue);
          vid = vid * pattern3brightness;

          if(patternIdx == 0.){
            outgoingLight = noiseColor;
          }else if(patternIdx == 1.0){
            outgoingLight = final;
          }else{
            outgoingLight = vid;
          }

          #ifdef OPAQUE
          diffuseColor.a = 1.0;
          #endif
          // https://github.com/mrdoob/three.js/pull/22425
          #ifdef USE_TRANSMISSION
          diffuseColor.a *= transmissionAlpha + 0.1;
          #endif
          gl_FragColor = vec4( outgoingLight, diffuseColor.a );
          `,
        ].join("\n")
      );

      material.userData.shader = shader;
    };

    return material;
  }, []);

  ////////////////////////////////////////////////////////////

  const ctx = useContext(UIContext);

  useFrame((state, delta) => {
    matScreen.userData.uTime.value = _delta;
    matScreen.userData.uTime2.value = _delta2;

    matScreen.userData.patternIdx.value = patternIdx;
    matScreen.userData.texVideo = texVideo;

    matScreen.userData.pattern1hue.value = ctx.sliderA.val0 * 3.14159265359 * 2;
    matScreen.userData.pattern1speed.value = 1.0;
    matScreen.userData.pattern1brightness.value = ctx.sliderA.val2 * 1.5;

    matScreen.userData.pattern2length.value = ctx.sliderB.val0;
    matScreen.userData.pattern2brightness.value = ctx.sliderB.val2;

    matScreen.userData.pattern3hue.value = ctx.sliderC.val0 * 3.14159265359 * 2;
    matScreen.userData.pattern3gamma.value = ctx.sliderC.val1;
    matScreen.userData.pattern3brightness.value = ctx.sliderC.val2;

    _delta += ctx.sliderA.val1 * 0.02;
    _delta2 += ctx.sliderB.val1 * 0.03;

    if (ctx.transition.isZoomEnd && !isLock) {
      state.camera.position.x = MathUtils.lerp(
        state.camera.position.x,
        pos.x - state.mouse.x * bias,
        0.02
      );
      state.camera.position.y = MathUtils.lerp(
        state.camera.position.y,
        pos.y + (state.mouse.y * bias) / 2,
        0.02
      );
    }
  });

  ////////////////////////////////////////////////////////////

  const camera = useThree((state) => state.camera);
  const pan = 80;

  const minPan = new Vector3(-pan, -pan, -pan);
  const maxPan = new Vector3(pan, pan, pan);
  const v = new Vector3();

  ////////////////////////////////////////////////////////////

  const [mapEnable, setMapEnable] = useState(false);
  const sound = useRef();

  ////////////////////////////////////////////////////////////

  const [listener] = useState(() => new AudioListener());
  const buffer = useLoader(AudioLoader, "/din.webm");

  const reflect = useMemo(() => {
    return (
      <MeshReflectorMaterial
        blur={[300, 100]}
        resolution={1024}
        mixBlur={0.8}
        mixStrength={10}
        roughness={1}
        depthScale={1.2}
        minDepthThreshold={0.4}
        maxDepthThreshold={1.4}
        color="#111111"
        mirror={1}
        reflectorOffset={0}
        distortionMap={normAsphalt}
        distortion={0.05}
        metalness={0}
        normalMap={normAsphalt}
        normalScale={new Vector2(5, 5)}
        depthToBlurRatioBias={1}
      />
    );
  }, []);

  useEffect(() => {
    sound.current.setBuffer(buffer);
    sound.current.setRefDistance(10);
    sound.current.setLoop(true);

    camera.add(listener);

    //window.addEventListener("touchstart", () => {
    //sound.current.play();
    //});

    return () => {
      camera.remove(listener);
    };
  }, []);

  useEffect(() => {
    props.changePattern.current = changePattern;
    props.cameraDefaultAngle.current = cameraDefaultAngle;
    props.cameraStart.current = cameraStart;
    props.toggleAudio.current = toggleAudio;
    props.captureImage.current = captureImage;
    props.toggleVideo.current = toggleVideo;

    props.zoomRef.current = isZoom;
  }, []);

  const { colBuildings } = useSpringThree({
    colBuildings: props.isNight
      ? [0, 0, 0]
      : [0.024157632443547246, 0.030713443727452196, 0.04518620437910499],
  });

  const { colCrowd } = useSpringThree({
    colCrowd: props.isNight
      ? [0, 0, 0]
      : [0.024157632443547246, 0.030713443727452196, 0.04518620437910499],
  });

  const { colBg } = useSpringThree({
    colBg: props.isNight
      ? [0, 0, 0]
      : [0.6038273388475408, 0.6038273388475408, 0.6038273388475408],
  });

  ////////////////////////////////////////////////////////////

  const { gl } = useThree();

  function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  async function captureImage() {
    await timeout(1000);
    saveAs(gl.domElement.toDataURL("image/png"), "media_facade_simulator.png");
  }

  const crowdMaterial = useMemo(() => {
    const material = new MeshStandardMaterial();
    material.color = colCrowd;
    material.flatShading = true;
    material.roughness = 0.6;
    material.metalness = 0.4;
    material.instances = true;
    return material;
  }, [colCrowd]);

  const models = useMemo(() => {
    return {
      Crowd1: nodes.Crowd1,
      Crowd2: nodes.Crowd2,
      Crowd3: nodes.Crowd3,
      Crowd4: nodes.Crowd4,
      Crowd5: nodes.Crowd5,
    };
  }, []);

  ////////////////////////////////////////////////////////////

  return (
    <>
      <group ref={group} {...props} dispose={null}>
        <animatedThree.mesh geometry={nodes.buildings.geometry}>
          <animatedThree.meshStandardMaterial
            color={colCrowd}
            roughness={0.8}
            metalness={0.04}
          />
          <Edges color={props.isNight ? 0x555555 : 0x888888} />
        </animatedThree.mesh>

        <mesh rotation={[-Math.PI / 2, 0, 0]}>
          <mesh
            geometry={new PlaneBufferGeometry(400, 400, 1, 1)}
            position={[0, 0, 19]}
          >
            {reflect}
          </mesh>
        </mesh>

        {/*
        <animatedThree.mesh
          geometry={nodes.crowds.geometry}
          position={[0, -0.05, 0]}
        >
          <animatedThree.meshStandardMaterial
            color={colCrowd}
            flatShading
            roughness={0.6}
            metalness={0.4}
          />
        </animatedThree.mesh>
        */}

        {/*<Crowd />*/}

        {/*
        <Merged meshes={nodes}>
          {({ Crowd1, Crowd2, Crowd3, Crowd4, Crowd5 }) => (
            <>
              <animatedThree.group>
                <Crowd1
                  position={[38.9953, 19.0, 47.146]}
                  quaternion={[0.0, 0.944823, 0.0, -0.327581]}
                />
                <Crowd1
                  position={[5.12365, 19.0, 56.0789]}
                  quaternion={[0.0, 0.433741, 0.0, -0.901038]}
                />
                <Crowd1
                  position={[5.32498, 19.0, 76.8296]}
                  quaternion={[0.0, 0.999878, 0.0, 0.0156144]}
                />
                <Crowd1
                  position={[16.5214, 19.0, 69.9321]}
                  quaternion={[-0.0, -0.615293, -0.0, 0.788298]}
                />
                <Crowd1
                  position={[35.5828, 19.0, 58.2693]}
                  quaternion={[-0.0, -0.49702, -0.0, 0.867739]}
                />
                <Crowd1
                  position={[-0.340277, 19.0, 79.9204]}
                  quaternion={[0.0, 0.459826, 0.0, -0.888009]}
                />
                <Crowd1
                  position={[23.7429, 19.0, 76.1625]}
                  quaternion={[0.0, 0.942894, 0.0, 0.333093]}
                />
                <Crowd1
                  position={[20.159, 19.0, 63.9515]}
                  quaternion={[0.0, 0.982756, 0.0, 0.184907]}
                />
                <Crowd1
                  position={[32.885, 19.0, 58.5378]}
                  quaternion={[-0.0, -0.0738201, -0.0, -0.997272]}
                />
                <Crowd1
                  position={[12.8487, 19.0, 82.6045]}
                  quaternion={[-0.0, -0.961127, -0.0, -0.276107]}
                />
                <Crowd1
                  position={[32.0263, 19.0, 64.6014]}
                  quaternion={[-0.0, -0.957517, -0.0, 0.288376]}
                />
                <Crowd1
                  position={[-0.659469, 19.0, 76.3745]}
                  quaternion={[0.0, 0.946442, 0.0, -0.322873]}
                />
                <Crowd1
                  position={[11.4914, 19.0, 55.6373]}
                  quaternion={[0.0, 0.939912, 0.0, -0.341417]}
                />
                <Crowd1
                  position={[14.1457, 19.0, 71.8675]}
                  quaternion={[-0.0, -0.933277, -0.0, 0.359156]}
                />
                <Crowd1
                  position={[16.8198, 19.0, 46.1279]}
                  quaternion={[0.0, 0.139971, 0.0, -0.990156]}
                />
                <Crowd1
                  position={[21.5468, 19.0, 38.6364]}
                  quaternion={[0.0, 0.403952, 0.0, 0.91478]}
                />
                <Crowd1
                  position={[2.42836, 19.0, 73.1626]}
                  quaternion={[-0.0, -0.915933, -0.0, -0.401332]}
                />
                <Crowd1
                  position={[9.23738, 19.0, 61.2726]}
                  quaternion={[0.0, 0.918001, 0.0, 0.396578]}
                />

                <Crowd2
                  position={[37.0052, 19.0, 67.6078]}
                  quaternion={[0.0, 0.393735, 0.0, 0.919224]}
                />
                <Crowd2
                  position={[16.5125, 19.0, 40.6771]}
                  quaternion={[-0.0, -0.914699, -0.0, -0.404135]}
                />
                <Crowd2
                  position={[9.7043, 19.0, 41.1198]}
                  quaternion={[0.0, 0.603275, 0.0, 0.797533]}
                />
                <Crowd2
                  position={[5.08684, 19.0, 36.2031]}
                  quaternion={[0.0, 0.903858, 0.0, 0.427833]}
                />
                <Crowd2
                  position={[14.5406, 19.0, 49.3291]}
                  quaternion={[-0.0, -0.0357514, -0.0, -0.999361]}
                />
                <Crowd2
                  position={[40.6174, 19.0, 62.7386]}
                  quaternion={[0.0, 0.339457, 0.0, -0.940621]}
                />
                <Crowd2
                  position={[29.1501, 19.0, 41.572]}
                  quaternion={[0.0, 0.990027, 0.0, 0.140879]}
                />
                <Crowd2
                  position={[41.8765, 19.0, 55.8248]}
                  quaternion={[-0.0, -0.900852, -0.0, -0.434126]}
                />
                <Crowd2
                  position={[18.6096, 19.0, 72.7575]}
                  quaternion={[0.0, 0.00597714, 0.0, -0.999982]}
                />
                <Crowd2
                  position={[7.47506, 19.0, 53.7551]}
                  quaternion={[0.0, 0.33962, 0.0, 0.940563]}
                />
                <Crowd2
                  position={[8.70909, 19.0, 36.8506]}
                  quaternion={[0.0, 0.575906, 0.0, 0.817516]}
                />
                <Crowd2
                  position={[1.9689, 19.0, 55.5086]}
                  quaternion={[-0.0, -0.610012, -0.0, -0.792392]}
                />
                <Crowd2
                  position={[14.9739, 19.0, 53.9771]}
                  quaternion={[0.0, 0.978977, 0.0, -0.203972]}
                />
                <Crowd2
                  position={[10.7786, 19.0, 70.2228]}
                  quaternion={[0.0, 0.727132, 0.0, 0.686497]}
                />
                <Crowd2
                  position={[12.8731, 19.0, 61.4616]}
                  quaternion={[0.0, 0.544689, 0.0, 0.838638]}
                />
                <Crowd2
                  position={[18.8156, 19.0, 42.8182]}
                  quaternion={[-0.0, -0.993084, -0.0, -0.117408]}
                />
                <Crowd2
                  position={[40.6279, 19.0, 59.2512]}
                  quaternion={[0.0, 0.995848, 0.0, 0.0910352]}
                />
                <Crowd2
                  position={[22.0483, 19.0, 70.0468]}
                  quaternion={[0.0, 0.998907, 0.0, -0.0467483]}
                />
                <Crowd2
                  position={[38.594, 19.0, 54.8354]}
                  quaternion={[-0.0, -0.926358, -0.0, -0.376644]}
                />
                <Crowd2
                  position={[5.54789, 19.0, 28.8868]}
                  quaternion={[0.0, 0.39977, 0.0, -0.916615]}
                />
                <Crowd2
                  position={[23.2799, 19.0, 33.0751]}
                  quaternion={[-0.0, -0.411032, -0.0, -0.911621]}
                />
                <Crowd2
                  position={[7.38177, 19.0, 58.2902]}
                  quaternion={[0.0, 0.988828, 0.0, 0.149061]}
                />
                <Crowd2
                  position={[-0.596424, 19.0, 82.8181]}
                  quaternion={[-0.0, -0.69011, -0.0, -0.723704]}
                />
                <Crowd2
                  position={[11.6084, 19.0, 38.4775]}
                  quaternion={[-0.0, -0.999227, -0.0, -0.039321]}
                />
                <Crowd2
                  position={[14.9577, 19.0, 79.677]}
                  quaternion={[0.0, 0.96263, 0.0, 0.270819]}
                />
                <Crowd2
                  position={[16.7419, 19.0, 34.2564]}
                  quaternion={[-0.0, -0.695303, -0.0, 0.718716]}
                />
                <Crowd2
                  position={[-3.14729, 19.0, 33.7328]}
                  quaternion={[0.0, 0.659462, 0.0, 0.751738]}
                />

                <Crowd3
                  position={[23.162, 19.0, 65.0741]}
                  quaternion={[-0.0, -0.292176, -0.0, 0.956365]}
                />
                <Crowd3
                  position={[26.1501, 19.0, 49.5982]}
                  quaternion={[0.0, 0.502535, 0.0, 0.864557]}
                />
                <Crowd3
                  position={[10.8879, 19.0, 58.819]}
                  quaternion={[-0.0, -0.947049, -0.0, -0.321088]}
                />
                <Crowd3
                  position={[29.5803, 19.0, 54.566]}
                  quaternion={[0.0, 0.409864, 0.0, -0.912147]}
                />
                <Crowd3
                  position={[-4.45544, 19.0, 76.1296]}
                  quaternion={[0.0, 0.990787, 0.0, -0.135431]}
                />
                <Crowd3
                  position={[12.8175, 19.0, 44.8402]}
                  quaternion={[0.0, 0.997429, 0.0, -0.0716545]}
                />
                <Crowd3
                  position={[35.0144, 19.0, 44.5253]}
                  quaternion={[0.0, 0.00508921, 0.0, 0.999987]}
                />
                <Crowd3
                  position={[5.04753, 19.0, 52.6488]}
                  quaternion={[0.0, 0.02576, 0.0, -0.999668]}
                />
                <Crowd3
                  position={[2.87938, 19.0, 60.4537]}
                  quaternion={[-0.0, -0.806793, -0.0, -0.590834]}
                />
                <Crowd3
                  position={[13.5282, 19.0, 41.0187]}
                  quaternion={[0.0, 0.638276, 0.0, -0.769808]}
                />
                <Crowd3
                  position={[2.92769, 19.0, 80.2981]}
                  quaternion={[-0.0, -0.696888, -0.0, 0.71718]}
                />
                <Crowd3
                  position={[-8.74806, 19.0, 51.056]}
                  quaternion={[-0.0, -0.923283, -0.0, -0.384121]}
                />
                <Crowd3
                  position={[18.1947, 19.0, 53.6622]}
                  quaternion={[-0.0, -0.895314, -0.0, 0.445435]}
                />
                <Crowd3
                  position={[30.8602, 19.0, 59.4509]}
                  quaternion={[0.0, 0.99769, 0.0, -0.0679377]}
                />
                <Crowd3
                  position={[6.41401, 19.0, 33.1875]}
                  quaternion={[-0.0, -0.922849, -0.0, -0.385162]}
                />
                <Crowd3
                  position={[13.9679, 19.0, 76.3274]}
                  quaternion={[-0.0, -0.934055, -0.0, -0.35713]}
                />
                <Crowd3
                  position={[-0.759772, 19.0, 57.1371]}
                  quaternion={[-0.0, -0.611694, -0.0, 0.791094]}
                />
                <Crowd3
                  position={[32.5161, 19.0, 52.8024]}
                  quaternion={[-0.0, -0.968348, -0.0, -0.249603]}
                />
                <Crowd3
                  position={[18.4501, 19.0, 79.9491]}
                  quaternion={[0.0, 0.919213, 0.0, 0.393761]}
                />
                <Crowd3
                  position={[18.0465, 19.0, 67.1537]}
                  quaternion={[0.0, 0.178489, 0.0, 0.983942]}
                />
                <Crowd3
                  position={[-7.79891, 19.0, 47.3747]}
                  quaternion={[0.0, 0.923951, 0.0, -0.38251]}
                />
                <Crowd3
                  position={[46.8015, 19.0, 54.6086]}
                  quaternion={[0.0, 0.281382, 0.0, -0.959596]}
                />

                <Crowd4
                  position={[21.4568, 19.0, 45.9242]}
                  quaternion={[0.0, 0.879959, 0.0, -0.47505]}
                />
                <Crowd4
                  position={[0.0570613, 19.0, 43.4605]}
                  quaternion={[0.0, 0.185413, 0.0, -0.982661]}
                />
                <Crowd4
                  position={[15.9748, 19.0, 58.5133]}
                  quaternion={[0.0, 0.335524, 0.0, 0.942032]}
                />
                <Crowd4
                  position={[1.40381, 19.0, 70.2086]}
                  quaternion={[-0.0, -0.975646, -0.0, -0.21935]}
                />
                <Crowd4
                  position={[35.2564, 19.0, 51.4906]}
                  quaternion={[0.0, 0.409971, 0.0, -0.912098]}
                />
                <Crowd4
                  position={[0.365753, 19.0, 62.3572]}
                  quaternion={[-0.0, -0.992446, -0.0, -0.122683]}
                />
                <Crowd4
                  position={[8.89854, 19.0, 31.0042]}
                  quaternion={[-0.0, -0.777467, -0.0, 0.628924]}
                />
                <Crowd4
                  position={[3.017, 19.0, 44.6557]}
                  quaternion={[-0.0, -0.245809, -0.0, 0.969318]}
                />
                <Crowd4
                  position={[13.5699, 19.0, 57.6211]}
                  quaternion={[0.0, 0.27857, 0.0, 0.960416]}
                />
                <Crowd4
                  position={[7.65337, 19.0, 74.669]}
                  quaternion={[0.0, 0.89043, 0.0, 0.45512]}
                />
                <Crowd4
                  position={[-7.34417, 19.0, 33.5724]}
                  quaternion={[0.0, 0.834791, 0.0, -0.550567]}
                />
                <Crowd4
                  position={[23.1718, 19.0, 57.5747]}
                  quaternion={[-0.0, -0.990007, -0.0, 0.141021]}
                />
                <Crowd4
                  position={[34.9948, 19.0, 55.0198]}
                  quaternion={[0.0, 0.816346, 0.0, -0.577563]}
                />
                <Crowd4
                  position={[2.86222, 19.0, 32.8326]}
                  quaternion={[0.0, 0.318321, 0.0, -0.947983]}
                />
                <Crowd4
                  position={[11.2528, 19.0, 47.7201]}
                  quaternion={[0.0, 0.965097, 0.0, -0.261891]}
                />
                <Crowd5
                  position={[-4.75434, 19.0, 29.984]}
                  quaternion={[-0.0, -0.104405, -0.0, -0.994535]}
                />
                <Crowd5
                  position={[10.127, 19.0, 34.1011]}
                  quaternion={[-0.0, -0.597376, -0.0, 0.801961]}
                />
                <Crowd5
                  position={[21.5267, 19.0, 60.5725]}
                  quaternion={[0.0, 0.957208, 0.0, 0.2894]}
                />
                <Crowd5
                  position={[3.89804, 19.0, 58.4504]}
                  quaternion={[-0.0, -0.935537, -0.0, -0.353228]}
                />
                <Crowd5
                  position={[-0.831899, 19.0, 50.723]}
                  quaternion={[-0.0, -0.913484, -0.0, 0.406875]}
                />
                <Crowd5
                  position={[5.52026, 19.0, 87.7874]}
                  quaternion={[-0.0, -0.876623, -0.0, 0.481177]}
                />
                <Crowd5
                  position={[35.5449, 19.0, 62.6199]}
                  quaternion={[0.0, 0.898185, 0.0, -0.439617]}
                />
                <Crowd5
                  position={[8.14285, 19.0, 45.7369]}
                  quaternion={[-0.0, -0.978779, -0.0, -0.204916]}
                />
                <Crowd5
                  position={[3.03313, 19.0, 66.7614]}
                  quaternion={[0.0, 0.981939, 0.0, 0.189196]}
                />
                <Crowd5
                  position={[2.33441, 19.0, 76.8021]}
                  quaternion={[-0.0, -0.824651, -0.0, -0.565642]}
                />
                <Crowd5
                  position={[3.50594, 19.0, 51.5016]}
                  quaternion={[-0.0, -0.707487, -0.0, -0.706726]}
                />
                <Crowd5
                  position={[17.6071, 19.0, 62.3864]}
                  quaternion={[0.0, 0.9781, 0.0, -0.208136]}
                />
                <Crowd5
                  position={[19.6696, 19.0, 36.0387]}
                  quaternion={[0.0, 0.670595, 0.0, 0.741823]}
                />
                <Crowd5
                  position={[25.5291, 19.0, 59.6877]}
                  quaternion={[-0.0, -0.359656, -0.0, 0.933085]}
                />
                <Crowd5
                  position={[27.258, 19.0, 56.9492]}
                  quaternion={[0.0, 0.0863978, 0.0, -0.996261]}
                />
                <Crowd5
                  position={[29.9968, 19.0, 49.655]}
                  quaternion={[0.0, 0.116816, 0.0, 0.993154]}
                />
                <Crowd5
                  position={[5.10585, 19.0, 64.138]}
                  quaternion={[-0.0, -0.294776, -0.0, -0.955566]}
                />
                <Crowd5
                  position={[11.6389, 19.0, 78.9759]}
                  quaternion={[0.0, 0.0698523, 0.0, -0.997557]}
                />
              </animatedThree.group>

              <animatedThree.meshStandardMaterial
                color={colCrowd}
                flatShading
                roughness={0.6}
                metalness={0.4}
              />
            </>
          )}
        </Merged>
         */}
        <group position={[0, -0.05, 0]}>
          <Instances geometry={models.Crowd1.geometry}>
            <animatedThree.meshStandardMaterial
              color={colCrowd}
              flatShading
              roughness={0.6}
              metalness={0.4}
            />

            <Instance
              position={[-4.75434, 19.0, 29.984]}
              quaternion={[-0.0, -0.104405, -0.0, -0.994535]}
            />
            <Instance
              position={[10.127, 19.0, 34.1011]}
              quaternion={[-0.0, -0.597376, -0.0, 0.801961]}
            />
            <Instance
              position={[21.5267, 19.0, 60.5725]}
              quaternion={[0.0, 0.957208, 0.0, 0.2894]}
            />
            <Instance
              position={[3.89804, 19.0, 58.4504]}
              quaternion={[-0.0, -0.935537, -0.0, -0.353228]}
            />
            <Instance
              position={[-0.831899, 19.0, 50.723]}
              quaternion={[-0.0, -0.913484, -0.0, 0.406875]}
            />
            <Instance
              position={[5.52026, 19.0, 87.7874]}
              quaternion={[-0.0, -0.876623, -0.0, 0.481177]}
            />
            <Instance
              position={[35.5449, 19.0, 62.6199]}
              quaternion={[0.0, 0.898185, 0.0, -0.439617]}
            />
            <Instance
              position={[8.14285, 19.0, 45.7369]}
              quaternion={[-0.0, -0.978779, -0.0, -0.204916]}
            />
            <Instance
              position={[3.03313, 19.0, 66.7614]}
              quaternion={[0.0, 0.981939, 0.0, 0.189196]}
            />
            <Instance
              position={[2.33441, 19.0, 76.8021]}
              quaternion={[-0.0, -0.824651, -0.0, -0.565642]}
            />
            <Instance
              position={[3.50594, 19.0, 51.5016]}
              quaternion={[-0.0, -0.707487, -0.0, -0.706726]}
            />
            <Instance
              position={[17.6071, 19.0, 62.3864]}
              quaternion={[0.0, 0.9781, 0.0, -0.208136]}
            />
            <Instance
              position={[19.6696, 19.0, 36.0387]}
              quaternion={[0.0, 0.670595, 0.0, 0.741823]}
            />
            <Instance
              position={[25.5291, 19.0, 59.6877]}
              quaternion={[-0.0, -0.359656, -0.0, 0.933085]}
            />
            <Instance
              position={[27.258, 19.0, 56.9492]}
              quaternion={[0.0, 0.0863978, 0.0, -0.996261]}
            />
            <Instance
              position={[29.9968, 19.0, 49.655]}
              quaternion={[0.0, 0.116816, 0.0, 0.993154]}
            />
            <Instance
              position={[5.10585, 19.0, 64.138]}
              quaternion={[-0.0, -0.294776, -0.0, -0.955566]}
            />
            <Instance
              position={[11.6389, 19.0, 78.9759]}
              quaternion={[0.0, 0.0698523, 0.0, -0.997557]}
            />
          </Instances>

          <Instances geometry={models.Crowd2.geometry}>
            <animatedThree.meshStandardMaterial
              color={colCrowd}
              flatShading
              roughness={0.6}
              metalness={0.4}
            />

            <Instance
              position={[37.0052, 19.0, 67.6078]}
              quaternion={[0.0, 0.393735, 0.0, 0.919224]}
            />
            <Instance
              position={[16.5125, 19.0, 40.6771]}
              quaternion={[-0.0, -0.914699, -0.0, -0.404135]}
            />
            <Instance
              position={[9.7043, 19.0, 41.1198]}
              quaternion={[0.0, 0.603275, 0.0, 0.797533]}
            />
            <Instance
              position={[5.08684, 19.0, 36.2031]}
              quaternion={[0.0, 0.903858, 0.0, 0.427833]}
            />
            <Instance
              position={[14.5406, 19.0, 49.3291]}
              quaternion={[-0.0, -0.0357514, -0.0, -0.999361]}
            />
            <Instance
              position={[40.6174, 19.0, 62.7386]}
              quaternion={[0.0, 0.339457, 0.0, -0.940621]}
            />
            <Instance
              position={[29.1501, 19.0, 41.572]}
              quaternion={[0.0, 0.990027, 0.0, 0.140879]}
            />
            <Instance
              position={[41.8765, 19.0, 55.8248]}
              quaternion={[-0.0, -0.900852, -0.0, -0.434126]}
            />
            <Instance
              position={[18.6096, 19.0, 72.7575]}
              quaternion={[0.0, 0.00597714, 0.0, -0.999982]}
            />
            <Instance
              position={[7.47506, 19.0, 53.7551]}
              quaternion={[0.0, 0.33962, 0.0, 0.940563]}
            />
            <Instance
              position={[8.70909, 19.0, 36.8506]}
              quaternion={[0.0, 0.575906, 0.0, 0.817516]}
            />
            <Instance
              position={[1.9689, 19.0, 55.5086]}
              quaternion={[-0.0, -0.610012, -0.0, -0.792392]}
            />
            <Instance
              position={[14.9739, 19.0, 53.9771]}
              quaternion={[0.0, 0.978977, 0.0, -0.203972]}
            />
            <Instance
              position={[10.7786, 19.0, 70.2228]}
              quaternion={[0.0, 0.727132, 0.0, 0.686497]}
            />
            <Instance
              position={[12.8731, 19.0, 61.4616]}
              quaternion={[0.0, 0.544689, 0.0, 0.838638]}
            />
            <Instance
              position={[18.8156, 19.0, 42.8182]}
              quaternion={[-0.0, -0.993084, -0.0, -0.117408]}
            />
            <Instance
              position={[40.6279, 19.0, 59.2512]}
              quaternion={[0.0, 0.995848, 0.0, 0.0910352]}
            />
            <Instance
              position={[22.0483, 19.0, 70.0468]}
              quaternion={[0.0, 0.998907, 0.0, -0.0467483]}
            />
            <Instance
              position={[38.594, 19.0, 54.8354]}
              quaternion={[-0.0, -0.926358, -0.0, -0.376644]}
            />
            <Instance
              position={[5.54789, 19.0, 28.8868]}
              quaternion={[0.0, 0.39977, 0.0, -0.916615]}
            />
            <Instance
              position={[23.2799, 19.0, 33.0751]}
              quaternion={[-0.0, -0.411032, -0.0, -0.911621]}
            />
            <Instance
              position={[7.38177, 19.0, 58.2902]}
              quaternion={[0.0, 0.988828, 0.0, 0.149061]}
            />
            <Instance
              position={[-0.596424, 19.0, 82.8181]}
              quaternion={[-0.0, -0.69011, -0.0, -0.723704]}
            />
            <Instance
              position={[11.6084, 19.0, 38.4775]}
              quaternion={[-0.0, -0.999227, -0.0, -0.039321]}
            />
            <Instance
              position={[14.9577, 19.0, 79.677]}
              quaternion={[0.0, 0.96263, 0.0, 0.270819]}
            />
            <Instance
              position={[16.7419, 19.0, 34.2564]}
              quaternion={[-0.0, -0.695303, -0.0, 0.718716]}
            />
            <Instance
              position={[-3.14729, 19.0, 33.7328]}
              quaternion={[0.0, 0.659462, 0.0, 0.751738]}
            />
          </Instances>

          <Instances geometry={models.Crowd3.geometry}>
            <animatedThree.meshStandardMaterial
              color={colCrowd}
              flatShading
              roughness={0.6}
              metalness={0.4}
            />

            <Instance
              position={[23.162, 19.0, 65.0741]}
              quaternion={[-0.0, -0.292176, -0.0, 0.956365]}
            />
            <Instance
              position={[26.1501, 19.0, 49.5982]}
              quaternion={[0.0, 0.502535, 0.0, 0.864557]}
            />
            <Instance
              position={[10.8879, 19.0, 58.819]}
              quaternion={[-0.0, -0.947049, -0.0, -0.321088]}
            />
            <Instance
              position={[29.5803, 19.0, 54.566]}
              quaternion={[0.0, 0.409864, 0.0, -0.912147]}
            />
            <Instance
              position={[-4.45544, 19.0, 76.1296]}
              quaternion={[0.0, 0.990787, 0.0, -0.135431]}
            />
            <Instance
              position={[12.8175, 19.0, 44.8402]}
              quaternion={[0.0, 0.997429, 0.0, -0.0716545]}
            />
            <Instance
              position={[35.0144, 19.0, 44.5253]}
              quaternion={[0.0, 0.00508921, 0.0, 0.999987]}
            />
            <Instance
              position={[5.04753, 19.0, 52.6488]}
              quaternion={[0.0, 0.02576, 0.0, -0.999668]}
            />
            <Instance
              position={[2.87938, 19.0, 60.4537]}
              quaternion={[-0.0, -0.806793, -0.0, -0.590834]}
            />
            <Instance
              position={[13.5282, 19.0, 41.0187]}
              quaternion={[0.0, 0.638276, 0.0, -0.769808]}
            />
            <Instance
              position={[2.92769, 19.0, 80.2981]}
              quaternion={[-0.0, -0.696888, -0.0, 0.71718]}
            />
            <Instance
              position={[-8.74806, 19.0, 51.056]}
              quaternion={[-0.0, -0.923283, -0.0, -0.384121]}
            />
            <Instance
              position={[18.1947, 19.0, 53.6622]}
              quaternion={[-0.0, -0.895314, -0.0, 0.445435]}
            />
            <Instance
              position={[30.8602, 19.0, 59.4509]}
              quaternion={[0.0, 0.99769, 0.0, -0.0679377]}
            />
            <Instance
              position={[6.41401, 19.0, 33.1875]}
              quaternion={[-0.0, -0.922849, -0.0, -0.385162]}
            />
            <Instance
              position={[13.9679, 19.0, 76.3274]}
              quaternion={[-0.0, -0.934055, -0.0, -0.35713]}
            />
            <Instance
              position={[-0.759772, 19.0, 57.1371]}
              quaternion={[-0.0, -0.611694, -0.0, 0.791094]}
            />
            <Instance
              position={[32.5161, 19.0, 52.8024]}
              quaternion={[-0.0, -0.968348, -0.0, -0.249603]}
            />
            <Instance
              position={[18.4501, 19.0, 79.9491]}
              quaternion={[0.0, 0.919213, 0.0, 0.393761]}
            />
            <Instance
              position={[18.0465, 19.0, 67.1537]}
              quaternion={[0.0, 0.178489, 0.0, 0.983942]}
            />
            <Instance
              position={[-7.79891, 19.0, 47.3747]}
              quaternion={[0.0, 0.923951, 0.0, -0.38251]}
            />
            <Instance
              position={[46.8015, 19.0, 54.6086]}
              quaternion={[0.0, 0.281382, 0.0, -0.959596]}
            />
          </Instances>

          <Instances geometry={models.Crowd4.geometry}>
            <animatedThree.meshStandardMaterial
              color={colCrowd}
              flatShading
              roughness={0.6}
              metalness={0.4}
            />

            <Instance
              position={[21.4568, 19.0, 45.9242]}
              quaternion={[0.0, 0.879959, 0.0, -0.47505]}
            />
            <Instance
              position={[0.0570613, 19.0, 43.4605]}
              quaternion={[0.0, 0.185413, 0.0, -0.982661]}
            />
            <Instance
              position={[15.9748, 19.0, 58.5133]}
              quaternion={[0.0, 0.335524, 0.0, 0.942032]}
            />
            <Instance
              position={[1.40381, 19.0, 70.2086]}
              quaternion={[-0.0, -0.975646, -0.0, -0.21935]}
            />
            <Instance
              position={[35.2564, 19.0, 51.4906]}
              quaternion={[0.0, 0.409971, 0.0, -0.912098]}
            />
            <Instance
              position={[0.365753, 19.0, 62.3572]}
              quaternion={[-0.0, -0.992446, -0.0, -0.122683]}
            />
            <Instance
              position={[8.89854, 19.0, 31.0042]}
              quaternion={[-0.0, -0.777467, -0.0, 0.628924]}
            />
            <Instance
              position={[3.017, 19.0, 44.6557]}
              quaternion={[-0.0, -0.245809, -0.0, 0.969318]}
            />
            <Instance
              position={[13.5699, 19.0, 57.6211]}
              quaternion={[0.0, 0.27857, 0.0, 0.960416]}
            />
            <Instance
              position={[7.65337, 19.0, 74.669]}
              quaternion={[0.0, 0.89043, 0.0, 0.45512]}
            />
            <Instance
              position={[-7.34417, 19.0, 33.5724]}
              quaternion={[0.0, 0.834791, 0.0, -0.550567]}
            />
            <Instance
              position={[23.1718, 19.0, 57.5747]}
              quaternion={[-0.0, -0.990007, -0.0, 0.141021]}
            />
            <Instance
              position={[34.9948, 19.0, 55.0198]}
              quaternion={[0.0, 0.816346, 0.0, -0.577563]}
            />
            <Instance
              position={[2.86222, 19.0, 32.8326]}
              quaternion={[0.0, 0.318321, 0.0, -0.947983]}
            />
            <Instance
              position={[11.2528, 19.0, 47.7201]}
              quaternion={[0.0, 0.965097, 0.0, -0.261891]}
            />
          </Instances>

          <Instances geometry={models.Crowd5.geometry}>
            <animatedThree.meshStandardMaterial
              color={colCrowd}
              flatShading
              roughness={0.6}
              metalness={0.4}
            />

            <Instance
              position={[-4.75434, 19.0, 29.984]}
              quaternion={[-0.0, -0.104405, -0.0, -0.994535]}
            />
            <Instance
              position={[10.127, 19.0, 34.1011]}
              quaternion={[-0.0, -0.597376, -0.0, 0.801961]}
            />
            <Instance
              position={[21.5267, 19.0, 60.5725]}
              quaternion={[0.0, 0.957208, 0.0, 0.2894]}
            />
            <Instance
              position={[3.89804, 19.0, 58.4504]}
              quaternion={[-0.0, -0.935537, -0.0, -0.353228]}
            />
            <Instance
              position={[-0.831899, 19.0, 50.723]}
              quaternion={[-0.0, -0.913484, -0.0, 0.406875]}
            />
            <Instance
              position={[5.52026, 19.0, 87.7874]}
              quaternion={[-0.0, -0.876623, -0.0, 0.481177]}
            />
            <Instance
              position={[35.5449, 19.0, 62.6199]}
              quaternion={[0.0, 0.898185, 0.0, -0.439617]}
            />
            <Instance
              position={[8.14285, 19.0, 45.7369]}
              quaternion={[-0.0, -0.978779, -0.0, -0.204916]}
            />
            <Instance
              position={[3.03313, 19.0, 66.7614]}
              quaternion={[0.0, 0.981939, 0.0, 0.189196]}
            />
            <Instance
              position={[2.33441, 19.0, 76.8021]}
              quaternion={[-0.0, -0.824651, -0.0, -0.565642]}
            />
            <Instance
              position={[3.50594, 19.0, 51.5016]}
              quaternion={[-0.0, -0.707487, -0.0, -0.706726]}
            />
            <Instance
              position={[17.6071, 19.0, 62.3864]}
              quaternion={[0.0, 0.9781, 0.0, -0.208136]}
            />
            <Instance
              position={[19.6696, 19.0, 36.0387]}
              quaternion={[0.0, 0.670595, 0.0, 0.741823]}
            />
            <Instance
              position={[25.5291, 19.0, 59.6877]}
              quaternion={[-0.0, -0.359656, -0.0, 0.933085]}
            />
            <Instance
              position={[27.258, 19.0, 56.9492]}
              quaternion={[0.0, 0.0863978, 0.0, -0.996261]}
            />
            <Instance
              position={[29.9968, 19.0, 49.655]}
              quaternion={[0.0, 0.116816, 0.0, 0.993154]}
            />
            <Instance
              position={[5.10585, 19.0, 64.138]}
              quaternion={[-0.0, -0.294776, -0.0, -0.955566]}
            />
            <Instance
              position={[11.6389, 19.0, 78.9759]}
              quaternion={[0.0, 0.0698523, 0.0, -0.997557]}
            />
          </Instances>
        </group>

        {/* Point Icon */}

        <Html position={c2}>
          <div
            style={ctx.pointIcon.display ? {} : { pointerEvents: "none" }}
            onPointerOver={() => {
              document.getElementById("container").style.cursor = "pointer";
              if (!isLock && !isZoom) {
                props.cursor.current.dispSmall();
              }
            }}
            onPointerLeave={() => {
              document.getElementById("container").style.cursor = "initial";

              if (isStart && !isLock && !isZoom) {
                props.cursor.current.dispDrag();
              }
            }}
            onClick={(e) => {
              e.stopPropagation();
              props.cursor.current.dispMedium();
              camMove(1);
              ctx.pointIcon.display = false;

              props.toggleDefaultAngle.current();
              props.toggleCapture.current(true);
            }}
          >
            <PointIcon context={UIContext} cursor={props.cursor} />
          </div>
        </Html>

        <Html position={c3}>
          <div
            style={ctx.pointIcon.display ? {} : { pointerEvents: "none" }}
            onPointerOver={() => {
              document.getElementById("container").style.cursor = "pointer";
              if (!isLock && !isZoom) {
                props.cursor.current.dispSmall();
              }
            }}
            onPointerLeave={() => {
              document.getElementById("container").style.cursor = "initial";

              if (isStart && !isLock && !isZoom) {
                props.cursor.current.dispDrag();
              }
            }}
            onClick={(e) => {
              e.stopPropagation();
              props.cursor.current.dispMedium();
              camMove(2);
              ctx.pointIcon.display = false;

              props.toggleDefaultAngle.current();
              props.toggleCapture.current(true);
            }}
          >
            <PointIcon context={UIContext} cursor={props.cursor} />
          </div>
        </Html>

        <Html position={c4}>
          <div
            style={ctx.pointIcon.display ? {} : { pointerEvents: "none" }}
            onPointerOver={() => {
              document.getElementById("container").style.cursor = "pointer";
              if (!isLock && !isZoom) {
                props.cursor.current.dispSmall();
              }
            }}
            onPointerLeave={() => {
              document.getElementById("container").style.cursor = "initial";

              if (isStart && !isLock && !isZoom) {
                props.cursor.current.dispDrag();
              }
            }}
            onClick={(e) => {
              e.stopPropagation();
              props.cursor.current.dispMedium();
              camMove(3);
              ctx.pointIcon.display = false;

              props.toggleDefaultAngle.current();
              props.toggleCapture.current(true);
            }}
          >
            <PointIcon context={UIContext} cursor={props.cursor} />
          </div>
        </Html>

        <Html position={c5}>
          <div
            style={ctx.pointIcon.display ? {} : { pointerEvents: "none" }}
            onPointerOver={() => {
              document.getElementById("container").style.cursor = "pointer";
              if (!isLock && !isZoom) {
                props.cursor.current.dispSmall();
              }
            }}
            onPointerLeave={() => {
              document.getElementById("container").style.cursor = "initial";

              if (isStart && !isLock && !isZoom) {
                props.cursor.current.dispDrag();
              }
            }}
            onClick={(e) => {
              e.stopPropagation();
              props.cursor.current.dispMedium();
              camMove(4);
              ctx.pointIcon.display = false;

              props.toggleDefaultAngle.current();
              props.toggleCapture.current(true);
            }}
          >
            <PointIcon context={UIContext} cursor={props.cursor} />
          </div>
        </Html>

        <Html position={c6}>
          <div
            style={ctx.pointIcon.display ? {} : { pointerEvents: "none" }}
            onPointerOver={() => {
              document.getElementById("container").style.cursor = "pointer";
              if (!isLock && !isZoom) {
                props.cursor.current.dispSmall();
              }
            }}
            onPointerLeave={() => {
              document.getElementById("container").style.cursor = "initial";

              if (isStart && !isLock && !isZoom) {
                props.cursor.current.dispDrag();
              }
            }}
            onClick={(e) => {
              e.stopPropagation();
              props.cursor.current.dispMedium();
              camMove(5);
              ctx.pointIcon.display = false;

              props.toggleDefaultAngle.current();
              props.toggleCapture.current(true);
            }}
          >
            <PointIcon context={UIContext} cursor={props.cursor} />
          </div>
        </Html>

        {/* Audio Source */}
        <mesh position={new Vector3(0, 25, 20)} scale={1}>
          <positionalAudio ref={sound} args={[listener]} setVolume={0} />;
        </mesh>

        {/* 1 */}
        <mesh geometry={nodes.null_screen.geometry} material={matScreen} />

        {/* 2 */}
        <mesh geometry={nodes.null_screen_1.geometry} material={matScreen} />

        {/* 3 */}
        <mesh geometry={nodes.null_screen_2.geometry} material={matScreen} />

        {/* 4 */}
        <mesh geometry={nodes.null_screen_3.geometry} material={matScreen} />

        {/* 5 */}
        <mesh geometry={nodes.null_screen_4.geometry} material={matScreen} />

        {/* 6 */}
        <mesh geometry={nodes.null_screen_5.geometry} material={matScreen} />

        {/* 7 */}
        <mesh geometry={nodes.null_screen_6.geometry} material={matScreen} />

        {/* 8 */}
        <mesh geometry={nodes.null_screen_7.geometry} material={matScreen} />

        {/* 9 */}
        <mesh geometry={nodes.null_screen_8.geometry} material={matScreen} />

        {/* 10 */}
        <mesh geometry={nodes.null_screen_9.geometry} material={matScreen} />

        {/* 11 */}
        <mesh geometry={nodes.null_screen_10.geometry} material={matScreen} />

        {/* 12 */}
        <mesh geometry={nodes.null_screen_11.geometry} material={matScreen} />

        {/* 13 */}
        <mesh geometry={nodes.null_screen_12.geometry} material={matScreen} />

        {/* 14 */}
        <mesh geometry={nodes.null_screen_13.geometry} material={matScreen} />

        {/* 15 */}
        <mesh geometry={nodes.null_screen_14.geometry} material={matScreen} />

        {/* 16 */}
        <mesh geometry={nodes.null_screen_15.geometry} material={matScreen} />
      </group>

      {!isZoom && (
        <MapControls
          enabled={mapEnable}
          enableZoom={false}
          enableRotate={false}
          ref={mapRef}
          target={[-1.3302535316570783, 0, -49.41671018138349]}
          onChange={(e) => {
            // pan limit
            v.copy(e.target.target);
            e.target.target.clamp(minPan, maxPan);
            v.sub(e.target.target);
            camera.position.sub(v);
            //console.log(e.target);
            //console.log(camera.quaternion);
          }}
        />
      )}

      <animatedThree.mesh
        geometry={new BoxBufferGeometry(3000, 3000, 3000, 1, 1, 1)}
        position={[0, 0, -800]}
      >
        <animatedThree.meshBasicMaterial
          color={colBg}
          fog={false}
          side={DoubleSide}
        />
      </animatedThree.mesh>
    </>
  );
}

useGLTF.preload("/models.glb");
